if (!customElements.get('face-photo-form')) {
  customElements.define('face-photo-form', class FacePhotoForm extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';

      this.form = this.closest('form');
      this.subjectInput = this.querySelector('[name="properties[Photo subject]"]');
      this.nameInput = this.querySelector('[name="properties[Person or pet name]"]');
      this.notesInput = this.querySelector('[name="properties[Customization notes]"]');
      this.photoConfirm = this.querySelector('[name="properties[Photo quality confirmed]"], [name="properties[Photo delivery confirmed]"]');
      this.permissionConfirm = this.querySelector('[name="properties[Photo permission confirmed]"]');
      this.fileInput = this.querySelector('[data-face-file]');
      this.counter = this.querySelector('[data-face-count]');

      if (!this.form || !this.subjectInput || !this.nameInput || !this.notesInput || !this.photoConfirm || !this.permissionConfirm) return;

      this.allowedTypes = ['image/jpeg', 'image/png', 'image/webp'];
      this.maxBytes = 15 * 1024 * 1024;
      this.cacheKey = 'mofabia-face-photo-' + (this.dataset.productId || 'project');
      window.mofabiaFacePhotoDrafts = window.mofabiaFacePhotoDrafts || {};
      const saved = window.mofabiaFacePhotoDrafts[this.cacheKey];

      if (saved) {
        this.subjectInput.value = saved.subject || '';
        this.nameInput.value = saved.name || '';
        this.notesInput.value = saved.notes || '';
        this.photoConfirm.checked = Boolean(saved.photo);
        this.permissionConfirm.checked = Boolean(saved.permission);
      }

      this.subjectInput.addEventListener('change', () => {
        this.saveDraft();
        this.clearError('subject', this.subjectInput);
      });

      this.nameInput.addEventListener('input', () => {
        this.saveDraft();
        this.clearError('name', this.nameInput);
      });

      this.notesInput.addEventListener('input', () => {
        this.updateCounter();
        this.saveDraft();
      });

      if (this.fileInput) {
        this.fileInput.addEventListener('change', () => {
          this.updateFileState();
          this.validateFile(false);
        });
      }

      this.photoConfirm.addEventListener('change', () => {
        this.saveDraft();
        this.clearError('photo', this.photoConfirm);
      });

      this.permissionConfirm.addEventListener('change', () => {
        this.saveDraft();
        this.clearError('permission', this.permissionConfirm);
      });

      this.form.addEventListener('submit', (event) => {
        if (!this.validate()) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }, true);

      this.updateCounter();
    }

    updateCounter() {
      if (this.counter) this.counter.textContent = String(this.notesInput.value.length);
    }

    saveDraft() {
      window.mofabiaFacePhotoDrafts[this.cacheKey] = {
        subject: this.subjectInput.value,
        name: this.nameInput.value,
        notes: this.notesInput.value,
        photo: this.photoConfirm.checked,
        permission: this.permissionConfirm.checked
      };
    }

    updateFileState() {
      if (!this.fileInput) return;
      const label = this.fileInput.closest('.face-photo-form__upload');
      const filename = this.querySelector('[data-face-filename]');
      const file = this.fileInput.files && this.fileInput.files[0];
      if (filename) filename.textContent = file ? file.name : 'Choose photo';
      if (label) label.classList.toggle('is-selected', Boolean(file));
    }

    clearError(key, input) {
      input.removeAttribute('aria-invalid');
      const error = this.querySelector('[data-face-error="' + key + '"]');
      const label = input.closest('.face-photo-form__upload');
      if (error) error.textContent = '';
      if (label) label.classList.remove('is-invalid');
    }

    setError(key, input, message) {
      input.setAttribute('aria-invalid', 'true');
      const error = this.querySelector('[data-face-error="' + key + '"]');
      const label = input.closest('.face-photo-form__upload');
      if (error) error.textContent = message;
      if (label) label.classList.add('is-invalid');
    }

    validateFile(required) {
      if (!this.fileInput) return true;
      this.clearError('file', this.fileInput);
      const file = this.fileInput.files && this.fileInput.files[0];

      if (!file) {
        if (required) this.setError('file', this.fileInput, 'Upload one clear front-facing photo.');
        return !required;
      }

      if (!this.allowedTypes.includes(file.type)) {
        this.setError('file', this.fileInput, 'Choose a JPG, PNG or WebP image.');
        this.fileInput.value = '';
        this.updateFileState();
        return false;
      }

      if (file.size > this.maxBytes) {
        this.setError('file', this.fileInput, 'Choose an image smaller than 15 MB.');
        this.fileInput.value = '';
        this.updateFileState();
        return false;
      }

      return true;
    }

    validate() {
      let valid = true;
      this.clearError('subject', this.subjectInput);
      this.clearError('name', this.nameInput);
      this.clearError('photo', this.photoConfirm);
      this.clearError('permission', this.permissionConfirm);

      if (!this.subjectInput.value) {
        this.setError('subject', this.subjectInput, 'Choose whether the photo shows a person or pet.');
        valid = false;
      }

      if (!this.nameInput.value.trim()) {
        this.setError('name', this.nameInput, 'Enter the person or pet name.');
        valid = false;
      }

      if (!this.validateFile(Boolean(this.fileInput))) valid = false;

      if (!this.photoConfirm.checked) {
        this.setError('photo', this.photoConfirm, this.fileInput ? 'Confirm that the uploaded image is clear and front-facing.' : 'Confirm that you will email the required photo.');
        valid = false;
      }

      if (!this.permissionConfirm.checked) {
        this.setError('permission', this.permissionConfirm, 'Confirm that you have permission to use the photo.');
        valid = false;
      }

      if (!valid) {
        const firstInvalid = this.querySelector('[aria-invalid="true"]');
        if (firstInvalid) firstInvalid.focus();
      }

      return valid;
    }
  });
}